<template>
	<div class="EnergyStatistics">
		<Title firstName="暖通系统能耗统计" lastName="ENERGY CONSUMPTION STATISTICS'" />
		<div class="echarts">
		<div class="over">
			<div class="tag">
				<span :class="{active:acindex==0}" @click="changeIdx(0)">日</span>
				<span :class="{active:acindex==1}" @click="changeIdx(1)">月</span>
			</div>
		</div>
		<div id="hvacEnergy" ref="echarts" style="height: 19vh; width: 100%;margin-top:-1vh" />
		<div class="bottom"></div>
		</div>
	</div>
</template>

<script>
import * as echarts from "echarts";
const Title = () => import("../../../../components/title/Title");
const Graph = () => import("../../../../components/echarts/graph.vue");
const charts = () => import("../../../../components/echarts/charts.vue");
const SelectList = () => import("../../../../components/title/selectList.vue");

import { getMonthDays } from '../../../../utils/common/index'

export default {
	props:{
		energyData:{
			type:Array
		}
	},
	data() {
		return {
			myChart: null,
			acindex:0,
			tagList: [
				{
				id: 1,
				name: "日",
				},
				{
				id: 2,
				name: "月",
				},
			],
			xdata1:[], // 24小时
			xdata2:[], // 本月的日期
			option: {
				color: ["#5B8FF9", "#FF9D4D"],
				tooltip: {
				trigger: "axis", //坐标轴触发，主要在柱状图，折线图等会使用类目轴的图表中使用
				backgroundColor: "rgba(0, 10, 26, 0.8)",
				borderRadius: 8,
				borderWidth: 0,
				shadowColor: "rgba(13, 148, 255, 0.8)",
				axisPointer: {
					// 坐标轴指示器，坐标轴触发有效
					type: "line", // 默认为直线，可选为：'line' | 'shadow'
				},
				textStyle: {
					color: "#fff",
				},
				},
				legend: {
					itemWidth: 12,
					itemHeight: 12,
					x: "right",
					icon: "roundRect",
					textStyle: {
						color: "#ffffff",
					},
				},
				grid: {
					top: "18%",
					left: "3%",
					right: "6%",
					bottom: "3%",
					containLabel: true,
				},
				xAxis: {
					type: "category",
					boundaryGap: false,
					data: [],
					axisLine: {
						lineStyle: {
						color: "#0D94FF",
						},
				},
				axisLabel: {
					color: "#f0f0f0", //坐标轴的文本颜色
				},
				axisTick: {
					show: false, //去掉x轴刻度线
				},
				},
				yAxis: [
				{
					type: "value",
					name:"kWh",
					axisLine: {
					lineStyle: {
						color: "#f0f0f0",
					},
					},
					axisLabel: {
					color: "#f0f0f0", //坐标轴的文本颜色
					},
					axisTick: {
					show: false, //去掉x轴刻度线
					},
					splitLine: {
					//分割线
					lineStyle: {
						//分割线的样式
						color: ["rgba(230, 243, 253, 0.2)"],
						width: 1,
						type: "solid",
					},
					},
				},
				],
				series: [
					{
						name: "本月",
						type: "line",
						stack: "总量",
						showSymbol: false,
						areaStyle: {},
						data: [120, 132, 101, 134, 90, 230, 210],
					},
					{
						name: "上月",
						type: "line",
						showSymbol: false,
						stack: "总量",
						areaStyle: {},
						data: [220, 182, 191, 234, 290, 330, 310],
					},
				],
			},
		};
	},
	components: {
		Title,
		Graph,
		charts,
		SelectList,
	},
	created(){
		for (let i = 0; i <= 24; i++) {
            this.xdata1.push((i < 10 ? "0" + i : i) + ":00");
        }
        // 获取当月所有天数 
        this.xdata2 = getMonthDays()
	},
	mounted() {
		window.addEventListener('resize',this.chartResize)
		window.addEventListener('beforeunload', this.clearChart);
		this.changeIdx(0)
	},
	methods: {
		clearChart(){
			// 手动触发 destroy 相关的生命周期
			this.$destroy();
		},
		chartResize(){
			//防抖
			if(this.timer)
				clearTimeout(this.timer)
			this.timer = setTimeout(()=>{
				this.myChart.resize();
			},500)
		},
		changeIdx(idx){
            this.acindex = idx
			let date1 = idx == 0?'今日':'本月'
			let date2 = idx == 0?'昨日':'上月'
			let dian = idx == 0?new Date().getHours():new Date().getDate()
			
			this.option.xAxis.data = idx == 0?this.xdata1:this.xdata2
			this.option.series =  [
				{
					name: date1,
					type: "line",
					stack: "总量",
					showSymbol: false,
					areaStyle: {},
					data: this.energyData[idx][0].slice(0,dian),
				},
				{
					name: date2,
					type: "line",
					showSymbol: false,
					stack: "总量",
					areaStyle: {},
					data: this.energyData[idx][1],
				},
			]
			
			this.initCharts();

        },
		initCharts() {
			this.myChart = echarts.getInstanceByDom(document.getElementById("hvacEnergy"));
			if(this.myChart == null){
				this.myChart = echarts.init(document.getElementById("hvacEnergy"));
			}
			let xAxis = [];
			for (let i = 0; i < 12; i++) {
				xAxis.push(i + 1 + "月");
			}
			this.option && this.myChart.setOption(this.option);
		},
	},
  	beforeDestroy(){
        window.removeEventListener('resize', this.chartResize);
        window.removeEventListener('beforeunload', this.clearChart);
        if(!this.myChart) return 
        this.myChart.clear()
        this.myChart = null;  
    }
};
</script>

<style lang="less" scoped>
.EnergyStatistics {
	// height: 33.3vh;
	width: 20vw;
	// height: 493rem;
	position: fixed;
	top: 37.4vh;
	right: 1vw;
	z-index: 1;

	.echarts {
		position: relative;
		height: 25.5vh;
		padding-bottom: 1vh;
		background: linear-gradient(
		0deg,
		rgba(0, 33, 59, 0.6) 0%,
		rgba(3, 13, 24, 0.7) 100%
		);
		overflow: hidden;

		.bottom {
		width: 20vw;
		height: 1vh;
		background: url(../../../../assets/img/板块装饰线.png) no-repeat;
		block-size: 100% 100%;
		position: absolute;
		bottom: 0;
		left: 0;
		}
	}
}
</style>
